<script>
   import Submit from "./Submit.svelte";
   import Footer from "./components/Footer.svelte";
   import Post from "./Post.svelte";
   import { entities } from "./stores";
   import { inviewIdx } from "./stores";

   let containerHeight;
   let showSubmit = false;

   $: if ($inviewIdx == $entities.length - 2) {
      showSubmit = true;
   }
</script>

<div class="container" bind:clientHeight={containerHeight}>
   {#each $entities as stim}
      <div class="box">
         <Post {stim} />
      </div>
   {/each}
</div>

{#if showSubmit}
   <div class="submit">
      <Submit FeedType="swipe"/>
   </div>
{/if}

<Footer />

<svelte:head>
   <style type="text/css">
      html {
         overflow: hidden;
      }
   </style>
</svelte:head>

<style>
   .container {
      margin-bottom: 0px;
      /* height: 32rem;  */
      height: 28rem;
      /* background-color: blue; */
      scroll-snap-type: y mandatory;
      overflow-y: scroll;
   }
   .container::-webkit-scrollbar {
      display: none;
   }

   .container {
      -ms-overflow-style: none; /* IE and Edge */
      scrollbar-width: none; /* Firefox */
   }

   .box {
      scroll-snap-stop: always;
      margin-bottom: 8rem; /* adjust this to incr spacing btw posts  */
      /* background-color: aquamarine; */
      color: white;
      scroll-snap-align: center;
   }
   .submit {
      margin-top: 3px;
   }

   @media (max-height: 650px) {
      .container {
         height: 17rem;
      }
      .submit {
         margin-top: 2rem;
      }
   }

   @media (max-height: 750px) {
      .container {
         height: 21rem;
      }
      .submit {
         margin-top: 2rem;
      }
   }
</style>
